import React from 'react';
import Icon from 'components/AppIcon';
import Image from 'components/AppImage';

export default function GameMetaPanel({ game, isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div
      className="rounded-xl p-4 md:p-5 animate-fade-in-up"
      style={{ background: 'var(--color-card)', border: '1px solid var(--color-border)', boxShadow: 'var(--shadow-md)' }}
    >
      <div className="flex items-start justify-between mb-4">
        <h3 className="font-heading font-semibold text-base md:text-lg" style={{ color: 'var(--color-foreground)' }}>
          Game Info
        </h3>
        <button
          onClick={onClose}
          className="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-muted transition-colors"
          aria-label="Close info panel"
          style={{ color: 'var(--color-muted-foreground)' }}
        >
          <Icon name="X" size={16} />
        </button>
      </div>
      <div className="flex gap-3 mb-4">
        <div className="w-16 h-16 rounded-xl overflow-hidden flex-shrink-0">
          <Image
            src={game?.thumbnail}
            alt={game?.thumbnailAlt}
            className="w-full h-full object-cover"
          />
        </div>
        <div className="min-w-0">
          <p className="font-heading font-semibold text-sm md:text-base truncate" style={{ color: 'var(--color-foreground)' }}>
            {game?.title}
          </p>
          <p className="font-caption text-xs mt-0.5" style={{ color: 'var(--color-muted-foreground)' }}>
            by {game?.creator}
          </p>
          <div className="flex items-center gap-3 mt-1.5">
            <span className="flex items-center gap-1 font-caption text-xs" style={{ color: 'var(--color-muted-foreground)' }}>
              <Icon name="Play" size={12} />
              {game?.plays?.toLocaleString()} plays
            </span>
            <span className="flex items-center gap-1 font-caption text-xs" style={{ color: 'var(--color-muted-foreground)' }}>
              <Icon name="Star" size={12} color="var(--color-accent)" />
              {game?.rating}
            </span>
          </div>
        </div>
      </div>
      <div className="mb-4 p-3 rounded-lg" style={{ background: 'var(--color-muted)' }}>
        <p className="font-caption text-xs font-semibold mb-1" style={{ color: 'var(--color-muted-foreground)' }}>
          AI PROMPT
        </p>
        <p className="font-body text-sm italic" style={{ color: 'var(--color-foreground)' }}>
          &ldquo;{game?.prompt}&rdquo;
        </p>
      </div>
      <div className="grid grid-cols-2 gap-3">
        {[
          { label: 'Genre', value: game?.genre, icon: 'Tag' },
          { label: 'Difficulty', value: game?.difficulty, icon: 'Zap' },
          { label: 'Created', value: game?.createdAt, icon: 'Calendar' },
          { label: 'Engine', value: game?.engine, icon: 'Cpu' },
        ]?.map(({ label, value, icon }) => (
          <div key={label} className="flex items-center gap-2">
            <Icon name={icon} size={14} color="var(--color-primary)" />
            <div>
              <p className="font-caption text-xs" style={{ color: 'var(--color-muted-foreground)' }}>{label}</p>
              <p className="font-body text-xs font-medium" style={{ color: 'var(--color-foreground)' }}>{value}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}